module.exports = __webpack_public_path__ + "img/Boxes.9d4a5517.svg";